<template>
  <b-dropdown
    v-if="isLogin"
    class="alert-header"
    ref="header-alert"
    size="sm"
    variant="link"
    toggle-class="icn-route-btn alert-btn"
    menu-class="header-menu"
    no-caret
    right
    text="Right align"
    lazy
  >
    <template #button-content>
      <div class="alert_img">
        <img :src="`${$s3}/img/common/Header/alert.svg?${$ver}`" />
        <span v-if="newNoti" class="img_badge"></span>
      </div>
    </template>

    <AlertContent v-bind="{ goToAlert: goToAlert }"></AlertContent>
  </b-dropdown>
</template>

<script>
import { mapState } from 'vuex';

import AlertContent from '@/layouts/partials/Alert/AlertContent.vue';

export default {
  components: {
    AlertContent,
  },
  computed: {
    ...mapState(['isLogin', 'newNoti']),
  },
  methods: {
    goToAlert() {
      this.$refs['header-alert'].hide(true);
      this.$route.name !== 'Alert' && this.$router.push({ name: 'Alert' });
    },
  },
};
</script>
